/**
 * Pack.storageLimitBytes and scan totalBytes are in bytes. -1 means unlimited.
 */

export function getPackStorageLimitBytes(pack) {
  if (!pack || pack.storageLimitBytes == null) return null;
  const n = Number(pack.storageLimitBytes);
  if (Number.isNaN(n) || n < 0) return null;
  return n;
}

export function storageUsagePercent(usedBytes, limitBytes) {
  if (limitBytes == null || limitBytes <= 0) return null;
  const u = Number(usedBytes) || 0;
  return (u / limitBytes) * 100;
}

/** Percent for progress bar width (caps at 100; over-quota still shows full bar + exception state). */
export function clampedBarPercent(usedBytes, limitBytes) {
  const p = storageUsagePercent(usedBytes, limitBytes);
  if (p == null) return 0;
  return Math.min(100, Math.round(p * 10) / 10);
}

/**
 * @returns {'success' | 'active' | 'exception' | 'normal'}
 */
export function storageProgressStatus(usedBytes, limitBytes) {
  if (limitBytes == null || limitBytes <= 0) return "normal";
  const u = Number(usedBytes) || 0;
  if (u > limitBytes) return "exception";
  const p = (u / limitBytes) * 100;
  if (p >= 90) return "exception";
  if (p >= 70) return "active";
  return "success";
}
